import * as React from 'react';
import { useStore } from 'zustand';
import { CriteriaStoreContext } from '../context';

export const useNextPredicateOrder = ({ parentUuid }) => {
    const { store } = React.useContext(CriteriaStoreContext);
    if (!store) throw new Error('Missing CriteriaStoreContext.Provider in the tree');
    const predicates = useStore(store, (s) => s.predicates);
    const target = predicates?.[parentUuid] ? { ...predicates?.[parentUuid] } : null;
    const children = target?.predicates ?? [];

    const newPredicateOrder =
        children.reduce((acc, curr) => {
            return Math.max(...[predicates[curr]?.predicateOrder, acc]);
        }, 0) + 1;

    return newPredicateOrder;
};
